<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/series">シリーズ</router-link></li>
                <li class="breadcrumb-item">小説一覧</li>
            </ol>
        </nav>
        <div class="container">
            <legend v-if="$store.state.user">
                {{series.series_name}}
                小説一覧
                <a :href="'//' + $store.state.user.subdomain + $store.state.base_domain + '/author/series/' + $route.params.series_id" class="series-link" target="_blank">
                    シリーズページへ
                    <i class="fas fa-external-link-alt"></i>
                </a>
            </legend>
            <div class="text-muted small p-2 my-2">
                シリーズの小説を追加します。<br>
                ひとつの小説はひとつのシリーズに登録できます。
                複数のシリーズをまたいで登録することはできません。<br>
                シリーズ内でジャンルを跨いだ場合、先頭の作品のジャンルに表示されます。
            </div>
            <div class="d-flex justify-content-between">
                <div class="my-2">
                    <button type="button" class="btn btn-outline-success" @click="saveSort()" v-if="isSorted">
                        <i class="fas fa-sort-alpha-down"></i>
                        順番更新
                    </button>
                    <button type="button" class="btn btn-outline-secondary" @click="load()" v-if="isSorted">
                        <i class="fas fa-redo-alt"></i>
                        順番変更キャンセル
                    </button>
                </div>
                <div class="my-2">
                    <button type="button" class="btn btn-outline-primary" @click="showBooks()">
                        <i class="fas fa-plus"></i>
                        小説追加
                    </button>
                </div>
            </div>
            <div class="card my-2" v-for="(v, i) in books" :key="v.id">
                <div class="card-body">
                    <div class="d-flex flex-wrap flex-lg-nowrap justify-content-between">
                        <div>
                            <h5 class="card-title">
                                <span class="handle mr-2">
                                    {{v.title}}
                                </span>
                                <span class="badge mr-2" :class="{
                                    'unavailable': i > 0,
                                    'badge-secondary': i > 0,
                                    'badge-primary': i == 0
                                }" v-if="v.genre">
                                    {{v.genre.genre_name}}
                                </span>
                                <span class="badge badge-secondary" v-if="!v.is_long">短編</span>
                            </h5>
                            <p class="card-text small">{{$filters.truncate(v.description)}}</p>
                        </div>
                        <div class="pt-4">
                            <button type="button" class="btn btn-link" @click="select(v.id)" v-if="books.length > 1">
                                <i class="fas fa-sort" v-if="!selected"></i>
                                <i class="fas fa-sort-up" v-else-if="i < selectedIndex"></i>
                                <i class="fas fa-sort-down" v-else-if="i > selectedIndex"></i>
                                <i class="fas fa-times" v-else></i>
                                <span v-if="!selected">移動</span>
                                <span v-else-if="i < selectedIndex">この上へ移動</span>
                                <span v-else-if="i > selectedIndex">この下へ移動</span>
                                <span v-else>移動をキャンセル</span>
                            </button>
                            <button type="button" class="btn btn-link text-danger" @click="remove(v.id)">
                                <i class="fas fa-times"></i>
                                削除
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nothing" v-if="!books || !books.length">
                小説がありません。<br>
                小説を追加してください。
            </div>
        </div>
        <books-modal :series_id="$route.params.series_id" @saved="load()"></books-modal>
    </div>
</template>

<style scoped>
.series-link {
    font-size: .9rem;
}
.unavailable {
    opacity: .3;
}
</style>

<script>
import booksModal from "./booksModal";
export default {
    components: {
        booksModal
    },
    data() {
        return {
            books: [],
            series: {},
            selected: null,
            sorted: null,
        }
    },
    methods: {
        load() {
            this.loadBooks();
            this.loadSeries();
        },
        loadSeries() {
            axios.get("/mypage/series/edit", {params: {id: this.$route.params.series_id}}).then(res => {
                this.series = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        loadBooks() {
            axios.get("/mypage/series/books/get", {params: {series_id: this.$route.params.series_id}}).then(res => {
                this.books = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        showBooks() {
            $("#books-modal").modal();
        },
        saveSort() {
            axios.post("/mypage/series/books-sort", {
                books: this.books
            }).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        remove(id) {
            Swal.fire({
                title: "小説削除",
                html: `<div class="text-left">
                    指定の小説をシリーズから削除します。<br>
                    小説自体は削除されません。<br>
                    削除しますか？
                    </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/series/book/remove", {'id': id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => {
                        alert.err(err.response);
                    });
                }
            });
        },
        select(id) {
            if (!this.selected) {
                // 選択
                this.selected = id;
                this.sorted = id;
            } else if (this.selected === id) {
                // 選択解除
                this.selected = null;
                this.sorted = null;
            } else {
                // 並び替え
                const from = this.selectedIndex;
                const dest = _.findIndex(this.books, {id: id});     // fromを抜く前のindex
                const src = this.books.splice(from, 1);
                const to = _.findIndex(this.books, {id: id});       // fromを抜いた後のindex
                if (from < dest) {
                    // 下がる
                    this.books.splice(to + 1, 0, src[0]);
                } else {
                    // 上がる
                    this.books.splice(to, 0, src[0]);
                }
                this.sorted = this.selected;
                this.selected = null;
            }
        },
    },
    computed: {
        isSorted() {
            for (let i = 0; i < this.books.length; i++) {
                if (this.books[i].series_order != (i + 1)) {
                    return true;
                }
            }
            return false;
        },
        selectedIndex() {
            return _.findIndex(this.books, {id: this.selected});
        },
    },
    mounted() {
        this.load();
    }
}
</script>